import React, { useState } from 'react';

import 'swiper/css';
import styled from 'styled-components';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Color } from '@assets/constants';
import { FileType } from '@models/banner';
import { useBanners } from '@queries';
import { ActivityIndicator } from '@ui/ActivityIndicator';

export const BannerSlider = () => {
  const [fileHasLoaded, setFileHasLoaded] = useState<boolean>(false);
  const { data: banners } = useBanners();

  const navigateToBannerLink = (url: string) =>
    url && window.open(url, '_self');

  return (
    <StyledSwiper
      modules={[Autoplay]}
      autoplay={{ delay: 4000, disableOnInteraction: true }}
      loop
    >
      {banners.map((banner) => (
        <SwiperSlide key={banner.id}>
          <FileWrapper>
            {!fileHasLoaded && (
              <ActivityIndicator size={100} color={Color.ACCENT} />
            )}
            {banner.fileType === FileType.IMAGE ? (
              <Image
                src={banner.fileUrl}
                loaded={fileHasLoaded}
                onLoad={() => setFileHasLoaded(true)}
                onClick={() => navigateToBannerLink(banner.redirectUrl)}
              />
            ) : (
              <Video
                src={banner.fileUrl}
                loaded={fileHasLoaded}
                onLoadedData={() => setFileHasLoaded(true)}
                autoPlay
                muted
                loop
                playsInline
                onClick={() => navigateToBannerLink(banner.redirectUrl)}
              />
            )}
          </FileWrapper>
        </SwiperSlide>
      ))}
    </StyledSwiper>
  );
};

const FileWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Video = styled.video<{ loaded: boolean }>`
  width: 100%;
  ${({ loaded }) => !loaded && 'display: none;'}
`;

const Image = styled.img<{ loaded: boolean }>`
  width: 100%;
  height: 100%;
  ${({ loaded }) => !loaded && 'display: none;'}
`;

const StyledSwiper = styled(Swiper)`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(-0.5rem);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  aspect-ratio: 16 / 7.5;

  @media (min-width: 768px) {
    transform: translateY(0);
    border-radius: 30px;
  }
`;
